export enum PlagiarismServiceProviders {
    URKUND = 'urkund',
    TURNITIN = 'turnitin',
    CROSSPLAG = 'crossplag',
    EPHORUS = 'ephorus',
}
